import BotaoPessoa from '@/components/botoesMenu/BotaoPessoa';
import BotaoDiagnosticoSocioambiental from '@/components/botoesMenu/BotaoDiagnosticoSocioambiental';
import BotaoTerritorioArgentina from '@/components/botoesMenu/BotaoTerritorioArgentina';
import BotaoTerritorio from '@/components/botoesMenu/BotaoTerritorio';
import BotaoLaudos from '@/components/botoesMenu/BotaoLaudos';
import BotaoHome from '@/components/botoesMenu/BotaoHome';
import BotaoUsuarios from '@/components/botoesMenu/BotaoUsuarios';
import BotaoRelatorios from '@/components/botoesMenu/BotaoRelatorios';
import BotaoCompartilhamentoDados from '@/components/botoesMenu/BotaoCompartilhamentoDados';
import BotaoOperacoes from '@/components/botoesMenu/BotaoOperacoes';
import BotaoSig from '@/components/botoesMenu/BotaoSig';
import BotaoInteligencia from '@/components/botoesMenu/BotaoInteligencia';
import BotaoInteligenciaCarbono from '@/components/botoesMenu/BotaoInteligenciaCarbono';
import BotaoMonitoramento from '@/components/botoesMenu/BotaoMonitoramento';
import BotaoMonitoramentoSocioambiental from '@/components/botoesMenu/BotaoMonitoramentoSocioambiental';
import BotaoMonitoramentoAgricola from '@/components/botoesMenu/BotaoMonitoramentoAgricola';
import BotaoRastreabilidadeBungeEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeBungeEmpresa';
import BotaoRastreabilidadeBungeSubEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeBungeSubEmpresa';
import BotaoConfiguracaoRastreabilidade from '@/components/botoesMenu/BotaoConfiguracaoRastreabilidade';
import BotaoFiscalizacaoOperacoes from '@/components/botoesMenu/BotaoFiscalizacaoOperacoes';
import BotaoRastreabilidade from '@/components/botoesMenu/BotaoRastreabilidade';
import BotaoDashboardOperacoes from '@/components/botoesMenu/BotaoDashboardOperacoes';
import BotaoGestaoOperacoes from '@/components/botoesMenu/BotaoGestaoOperacoes';
import BotaoCertificacao from '@/components/botoesMenu/BotaoCertificacao';
import BotaoRastreabilidadeDashboardBungeEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeDashboardBungeEmpresa';
import BotaoRastreabilidadeGestaoBungeEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeGestaoBungeEmpresa';
import BotaoRelatorioRastreabilidade from '@/components/botoesMenu/BotaoRelatorioRastreabilidade';
import BotaoAnaliseDesmatamento from '@/components/botoesMenu/BotaoAnaliseDesmatamento.vue';
import BotaoDenuncia from '@/components/botoesMenu/BotaoDenuncia.vue';
import BotaoPreAnalise from '@/components/botoesMenu/BotaoPreAnalise.vue';

const isAdmin = {
    nome: 'isAdmin',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoDiagnosticoSocioambiental,
        BotaoUsuarios
    ]
};

const canAccessLaudos = {
    nome: 'canAccessLaudos',
    role: 'ROLE_FEATURE_MODULO_LAUDOS',
    permissoes: [BotaoLaudos]
};

const isRegular = {
    nome: 'isRegular',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental
    ]
};

const isAnalyst = {
    nome: 'isAnalyst',
    permissoes: [BotaoFiscalizacaoOperacoes]
};

const operacaoCadastrante = {
    nome: 'operacaoCadastrante',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoDiagnosticoSocioambiental
    ]
};

const operacaoAprovador = {
    nome: 'operacaoAprovador',
    permissoes: [
        BotaoHome,
        BotaoSig,
        BotaoPessoa,
        BotaoTerritorio,
        BotaoDiagnosticoSocioambiental
    ]
};

const isVegaAdmin = {
    nome: 'isVegaAdmin',
    permissoes: [BotaoRelatorios]
};

const monitoramentoAccess = {
    nome: 'monitoramentoAccess',
    permissoes: [BotaoMonitoramento],
    perfisPermitido: ['monitoramentoAccess']
};

const monitoramentoSocioambientalAccess = {
    nome: 'monitoramentoSocioambientalAccess',
    permissoes: [BotaoMonitoramentoSocioambiental],
    perfisPermitido: ['monitoramentoSocioambientalAccess']
};

const monitoramentoAgricolaAccess = {
    nome: 'monitoramentoAgricolaAccess',
    permissoes: [BotaoMonitoramentoAgricola],
    perfisPermitido: ['monitoramentoAgricolaAccess']
};

const inteligenciaAccess = {
    nome: 'inteligenciaAccess',
    permissoes: [BotaoInteligencia, BotaoInteligenciaCarbono],
    perfisPermitido: ['inteligenciaAccess']
};

const compartilhamentoDadosAccess = {
    nome: 'compartilhamentoDadosAccess',
    permissoes: [BotaoCompartilhamentoDados],
    perfisPermitido: ['compartilhamentoDadosAccess']
};

const operacaoAccess = {
    nome: 'operacaoAccess',
    permissoes: [BotaoOperacoes, BotaoGestaoOperacoes, BotaoDashboardOperacoes],
    perfisPermitido: ['operacaoAccess']
};

const rastreabilidadeBungeEmpresa = {
    nome: 'rastreabilidadeBungeEmpresa',
    permissoes: [
        BotaoRastreabilidadeBungeEmpresa,
        BotaoRastreabilidadeDashboardBungeEmpresa,
        BotaoRastreabilidadeGestaoBungeEmpresa
    ]
};

const rastreabilidadeBungeSubEmpresa = {
    nome: 'rastreabilidadeBungeSubEmpresa',
    permissoes: [BotaoRastreabilidadeBungeSubEmpresa]
};

const fiscalizacaoOperacaoAccess = {
    nome: 'fiscalizacaoOperacaoAccess',
    permissoes: [BotaoFiscalizacaoOperacoes],
    perfisPermitido: ['fiscalizacaoOperacaoAccess']
};

const rastreabilidadeRaizen = {
    nome: 'rastreabilidadeRaizen',
    permissoes: [BotaoRastreabilidade],
    perfisPermitido: ['rastreabilidadeRaizen']
};

const certificacao = {
    nome: 'certificacao',
    permissoes: [BotaoCertificacao, BotaoAnaliseDesmatamento]
};

const denuncia = {
    nome: 'denuncia',
    role: 'ROLE_FEATURE_DENUNCIA',
    permissoes: [BotaoDenuncia]
};

const preAnalise = {
    nome: 'preAnalise',
    role: 'ROLE_FEATURE_PRE_ANALISE_CREDITO',
    permissoes: [BotaoPreAnalise]
};

const relatorioRastreabilidade = {
    nome: 'relatorioRastreabilidade',
    permissoes: [BotaoRelatorioRastreabilidade]
};

const configuracaoRastreabilidade = {
    nome: 'configuracaoRastreabilidade',
    permissoes: [BotaoConfiguracaoRastreabilidade]
};

const perfilPermissao = [
    isAdmin,
    isRegular,
    isAnalyst,
    isVegaAdmin,
    operacaoCadastrante,
    operacaoAprovador,
    monitoramentoAccess,
    monitoramentoSocioambientalAccess,
    monitoramentoAgricolaAccess,
    inteligenciaAccess,
    compartilhamentoDadosAccess,
    operacaoAccess,
    rastreabilidadeBungeEmpresa,
    rastreabilidadeBungeSubEmpresa,
    fiscalizacaoOperacaoAccess,
    rastreabilidadeRaizen,
    certificacao,
    relatorioRastreabilidade,
    configuracaoRastreabilidade,
    canAccessLaudos,
    denuncia,
    preAnalise
];

const buscarPermissoesMenuFeature = dadosUsuario => {
    let botoes = [];

    // Adiciona os botões conforme as configurações
    perfilPermissao.forEach(({ nome: permissao, permissoes }) => {
        if (dadosUsuario[permissao]) {
            permissoes.forEach(componente => {
                if (!botoes.find(botao => botao === componente)) {
                    if (
                        componente.name ===
                            BotaoRastreabilidadeBungeEmpresa.name &&
                        dadosUsuario.configuracaoRastreabilidade &&
                        dadosUsuario.isAdmin
                    ) {
                        if (
                            !componente.componentOptions.actions[0][0].submenus.find(
                                buttonName =>
                                    buttonName.name ===
                                    BotaoConfiguracaoRastreabilidade.name
                            )
                        ) {
                            componente.componentOptions.actions[0][0].submenus.push(
                                BotaoConfiguracaoRastreabilidade
                            );
                        }
                    }
                    if (
                        componente.name ===
                        BotaoConfiguracaoRastreabilidade.name
                    ) {
                        if (
                            dadosUsuario.configuracaoRastreabilidade &&
                            dadosUsuario.isAdmin
                        ) {
                            botoes.push(componente);
                        }
                    } else if (permissoes.perfisPermitido) {
                        let temPermissao = false;
                        permissoes.perfisPermitido.forEach(perfilPermitido => {
                            if (dadosUsuario[perfilPermitido]) {
                                temPermissao = true;
                            }
                        });
                        if (temPermissao) {
                            botoes.push(componente);
                        }
                    } else {
                        botoes.push(componente);
                    }

                    // adiciona o botão que foi excluido por ser AR
                    if (
                        componente.name ===
                        BotaoRastreabilidadeBungeEmpresa.name
                    ) {
                        if (
                            !componente.componentOptions.actions[0][0].submenus.find(
                                buttonName =>
                                    buttonName.name ===
                                    BotaoRastreabilidadeDashboardBungeEmpresa.name
                            )
                        ) {
                            componente.componentOptions.actions[0][0].submenus.push(
                                BotaoRastreabilidadeDashboardBungeEmpresa
                            );
                        }
                    }
                }
            });
        }
    });

    // Adiciona e ordena os botões de Território para Argentina, Paraguay e Brasil
    if (dadosUsuario.ambienteLogado) {
        botoes = botoes.filter(
            component => component.name !== 'BotaoTerritorio'
        );
        const botoesPerfilArgentina = [BotaoTerritorioArgentina];
        const indexBotaoRepresentante = botoes.findIndex(
            botao => botao.name === 'BotaoRepresentante'
        );

        const botoesParaAdicionar =
            dadosUsuario.ambienteLogado === 'AR'
                ? botoesPerfilArgentina
                : [BotaoTerritorio];
        botoes.splice(indexBotaoRepresentante + 1, 0, ...botoesParaAdicionar);

        // MÓDULOS AINDA NÃO ADAPTADOS - "" e "BotaoRastreabilidadeDashboardBungeEmpresa"
        if (dadosUsuario.ambienteLogado === 'AR') {
            botoes = botoes.filter(
                component => component.name !== 'BotaoDiagnosticoSocioAmbiental'
            );

            botoes = botoes.filter(
                component =>
                    component.name !==
                    'BotaoRastreabilidadeDashboardBungeEmpresa'
            );
        }
    }

    // Remove os botões conforme as configurações
    perfilPermissao.forEach(pp => {
        if (dadosUsuario[pp.nome]) {
            if (pp.permissoesNaoPertidas) {
                pp.permissoesNaoPertidas.forEach(componente => {
                    botoes = botoes.filter(b => b.name !== componente.name);
                });
            }
        }
    });

    // Remove os botões que constam em submenus
    botoes.forEach(b => {
        if (b.componentOptions.actions[0][0].submenus) {
            b.componentOptions.actions[0][0].submenus =
                b.componentOptions.actions[0][0].submenus.filter(sm =>
                    botoes.includes(sm)
                );
            b.componentOptions.actions[0][0].submenus.forEach(sm => {
                botoes = botoes.filter(b => b.name !== sm.name);
            });
        }
    });

    const rolesCustoms = [
        'ROLE_FEATURE_DENUNCIA',
        'ROLE_FEATURE_PRE_ANALISE_CREDITO',
        'ROLE_FEATURE_MODULO_LAUDOS'
    ];

    rolesCustoms.forEach(rolCustom => {
        const temPermissao = dadosUsuario.authorities.find(
            el => el.authority === rolCustom
        );

        if (temPermissao) {
            const component = perfilPermissao.find(pp => pp.role === rolCustom);
            botoes.push(...component.permissoes);
        }
    });

    return botoes;
};

export default {
    buscarPermissoesMenuFeature
};
